module.exports = __webpack_public_path__ + "img/inter17.72f5941d.jpg";